// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__HzBUh","question":"Question_question__3Fq7W","description":"Question_description__3FiTC"};